"use strict";
/**
 * @module Features.Security
 */
Object.defineProperty(exports, "__esModule", { value: true });
var require_non_null_1 = require("./../../util/require-non-null");
/**
 * Implementation of {@link SystemPrincipal}
 *
 * @inheritdoc
 */
var SystemPrincipalImpl = /** @class */ (function () {
    /**
     * Create a SystemPrincipalImpl instance
     *
     * @param  name   the principal name
     * @param  roles  the principal's assigned roles
     */
    function SystemPrincipalImpl(name, roles, lockingPrincipal) {
        this.name = require_non_null_1.requireNonNull(name, 'name');
        this.roles = roles || [];
        this.lockingPrincipal = lockingPrincipal;
    }
    /**
     * Convert object to string
     *
     * @return a string representation of the SystemPrincipalImpl
     */
    SystemPrincipalImpl.prototype.toString = function () {
        return "SystemPrincipal [" + this.name + ", " + this.roles + "]";
    };
    return SystemPrincipalImpl;
}());
exports.SystemPrincipalImpl = SystemPrincipalImpl;



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/internal/features/security/system-principal.js
// module id = 1211
// module chunks = 1